var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe"},[_c('iframe',{staticClass:"iframe",attrs:{"title":"IFrame","src":_vm.iframeUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }